// removed by extract-text-webpack-plugin
module.exports = {"loader":"Spineer__loader__8BCFS","load2":"Spineer__load2__2uRBp"};


//////////////////
// WEBPACK FOOTER
// ./src/components/UI/Spinner/Spineer.css
// module id = 114
// module chunks = 2